import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import Select from "react-select";
import MDBadge from "components/MDBadge";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import CircularProgress from "@mui/material/CircularProgress";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css"
import nodata from "assets/images/nodata.png";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function TestUpload() {
  const [csvData, setCsvData] = useState([]);
  const [base64Data, setBase64Data] = useState("");
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [all_entry_tests, setAllEntryTests] = useState([]);
  const [campaign_id, setCampaignId] = useState("");
  const [entry_test_id, setEntryTestId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    Papa.parse(file, {
      complete: (result) => {
        // Filter out empty rows
        const filteredData = result.data.filter(row => {
          return row.application_id && row.application_id.trim() !== '' && 
                 row.obtained_test_marks && row.obtained_test_marks.trim() !== '';
        });
        
        setCsvData(filteredData);

        const csvString = Papa.unparse(filteredData);
        const base64String = btoa(csvString);
        setBase64Data(base64String);
      },
      header: true,
      skipEmptyLines: true, // This will skip empty lines
    });
  };

  const getCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getEntryTests = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/entrytest/get_entry_tests`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllEntryTests(data.entry_tests);
      })
      .catch((error) => console.log(error));
  };

  // Rows & Columns Injection
  const columns = [
    { Header: "#", accessor: "serial", align: "left" },
    { Header: "Application ID", accessor: "application_id", align: "left" },
    {
      Header: "Obtained Test Marks",
      accessor: "obtained_test_marks",
      align: "left",
    },
  ];

  const rows =
    csvData.length > 0
      ? csvData.map((data, index) => ({
          serial: index + 1,
          application_id: data.application_id,
          obtained_test_marks: data.obtained_test_marks,
        }))
      : [
          {
            serial: null,
            application_id: null,
            obtained_test_marks: null
          },
        ];

  // POST API Call with improved error handling and loader
  const postTestResults = async () => {
    if(campaign_id === "" || entry_test_id === "") {
      return toast.error("Please select campaign and entry test");
    }

    if(csvData.length === 0) {
      return toast.error("Please upload a CSV file with test results");
    }
    
    setIsLoading(true);
    
    let data = { 
      results: csvData, 
      campaign_id: campaign_id,
      entry_test_id: entry_test_id 
    };
    
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        `${BASE_URL}/application/test_result_upload`,
        requestOptions
      );

      const responseData = await response.json();

      if (!response.ok) {
        // Handle different HTTP error codes
        if (response.status === 400) {
          toast.error(responseData.message || "Invalid data provided. Please check your file format and try again.");
        } else if (response.status === 401) {
          toast.error("Authentication failed. Please login again.");
        } else if (response.status === 403) {
          toast.error("You don't have permission to upload test results.");
        } else if (response.status === 500) {
          toast.error("Server error occurred. Please try again later.");
        } else {
          toast.error(responseData.message || `Error: ${response.status} - ${response.statusText}`);
        }
        return;
      }

      // Success response
      toast.success(responseData.message || "Test Results Uploaded Successfully");
      setCsvData([]);
      setCampaignId("");
      setEntryTestId("");
      // Reset file input
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = "";
      }

    } catch (error) {
      console.error("Error uploading test results:", error);
      if (error.name === 'NetworkError' || error.message.includes('fetch')) {
        toast.error("Network error. Please check your internet connection and try again.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCampaign = (value) => {
    setCampaignId(value);
  };

  const handleEntryTest = (value) => {
    setEntryTestId(value);
  };

  useEffect(() => {
    getCampaigns();
    getEntryTests();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <div className="mt-3">
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
              >
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="flex-start"
                  spacing={1}
                >
                  <h4 style={{ color: "red" }}>
                    Please follow instructions below to ensure proper Test
                    Upload List:
                  </h4>
                  <h6 style={{ marginLeft: "10px" }}>
                    1. Make sure to review your Test Upload List data carefully
                    before upload.
                  </h6>
                  <h6 style={{ marginLeft: "10px" }}>
                    2. Separate Entry needs to be uploaded for each Test Result,
                    any list containing mixed Application IDs will not be
                    processed.
                  </h6>
                  <h6 style={{ marginLeft: "10px" }}>
                    3. Test Results file should only contain 2 columms with data
                    for &quot;application_id (Form No)&quot; and &quot;obtained_marks&quot;.
                    See the sample file:{" "}
                    <a href="sample_test_results.csv" download>
                      Sample Test Results Template
                    </a>
                  </h6>
                </Stack>
                <input
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                  accept=".csv"
                  disabled={isLoading}
                />
              </Stack>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <label htmlFor="filter_campaign_id">Campaign</label>
                <Select
                  inputId="filter_campaign_id"
                  classNamePrefix="select"
                  options={all_campaigns.map((campaign) => ({
                    value: campaign.id,
                    label: campaign.name,
                  }))}
                  value={
                    all_campaigns
                      .map((campaign) => ({ value: campaign.id, label: campaign.name }))
                      .find((option) => option.value === campaign_id) || null
                  }
                  onChange={(selected) => handleCampaign(selected ? selected.value : "")}
                  placeholder="Select Campaign"
                  isDisabled={isLoading}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="filter_entry_test_id">Entry Test</label>
                <Select
                  inputId="filter_entry_test_id"
                  classNamePrefix="select"
                  options={all_entry_tests.map((test) => ({
                    value: test.id,
                    label: test.title,
                  }))}
                  value={
                    all_entry_tests
                      .map((test) => ({ value: test.id, label: test.title }))
                      .find((option) => option.value === entry_test_id) || null
                  }
                  onChange={(selected) => handleEntryTest(selected ? selected.value : "")}
                  placeholder="Select Entry Test"
                  isDisabled={isLoading}
                />
              </div>
            </div>
            <Card
              className="mt-5 card1"
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Button
                  variant="outlined"
                  endIcon={
                    isLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <DownloadDoneIcon className="add-icon" />
                    )
                  }
                  onClick={postTestResults}
                  className="add-full-button"
                  disabled={isLoading}
                >
                  {isLoading ? "Uploading..." : "Post Results"}
                </Button>
              </MDBox>
              <MDBox pt={3}>
                {csvData && csvData.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                      alt="No data available"
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default TestUpload;